import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { PpmService } from '../ppm.service';
import { PpmRepository } from '@/store/ppm-state/ppm-state.repository';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { Ppm } from '@/types';
import { DialogObject } from '@/components/dialog/dialog.types';
import { DialogComponent } from '@/components/dialog/dialog.component';
import { getPpmVersionHistoryDataTableStructure } from './utils/ppm-history-data-table-object';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';

@Component({
  selector: 'sm-ppm-version-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent, DialogComponent, TranslateModule],
  templateUrl: './version-history.component.html',
  styleUrl: './version-history.component.scss',
})
export class PpmVersionHistoryComponent implements OnInit {
  ppmService = inject(PpmService);
  ppmRepository = inject(PpmRepository);
  router = inject(Router);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  id = this.activatedRoute.snapshot.params['id'] as number;

  //breadcrumb
  breadcrumb = [
    {
      label: '',
      routerLink: ['/ppm-history'],
    },
  ];

  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'ppm.actions.inspect',
      },
    },
    inspectAction: (row: Ppm) => {
      this.router.navigate([`ppm-inspect-plan/${row.id}/${row.version}`]);
    },
  };

  data: Ppm[] = [];
  datatableObject: DynamicDataTable = getPpmVersionHistoryDataTableStructure({
    store: this.ppmRepository,
    rowActions: this.rowActions,
  });

  @ViewChild('dialog') dialogComponent!: DialogComponent;
  ppmDialog?: DialogObject;

  loading = true;
  ngOnInit(): void {
    this.loadData();
  }

  redirectUpdatePpm() {
    this.router.navigate(['/ppm-edit-plan']);
  }

  loadData() {
    this.ppmService.getPpmHistory(this.id).subscribe({
      next: data => {
        this.data = data.content;
        this.loading = false;
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error.message || 'Une erreur est survenue lors de la récupération des ppms',
        });
      },
    });
    //set breadcrumb
    this.ppmService.getPpm(this.id).subscribe({
      next: data => {
        this.ppmRepository.set('response', data);
        this.breadcrumb[0].label = this.translate.instant(`ppm.pages.version_history`, { ppm_ref: data.ref });
      },
      error: () => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Une erreur est survenue lors de la récupération des ppms',
        });
      },
    });
  }
}
